import React, { useEffect } from 'react';
import './PopupNotification.css';

const PopupNotification = ({ message, className }) => {
  useEffect(() => {
    saveMessageToLocalstorage(message);
  }, [message]);

  const saveMessageToLocalstorage = (message) => {
    const existingMessages = localStorage.getItem('popupMessages');
    const parsedMessages = existingMessages ? JSON.parse(existingMessages) : [];

    const currentDateTime = new Date();
    const formattedDateTime = currentDateTime.toLocaleDateString() + ' | ' + currentDateTime.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });

    parsedMessages.push({ message, dateTime: formattedDateTime });

    localStorage.setItem('popupMessages', JSON.stringify(parsedMessages));
  };
  

  return (
    <div className={`popup-notification ${className}`}>
      <div className="message">{message}</div>
    </div>
  );
};

export default PopupNotification;
